export const EXTENSION_PAGE_PATH = '/extension';
export const EXTENSION_ZIP_PATH = '/streambuddy-companion.zip';
export const EXTENSION_FIREFOX_ZIP_PATH = '/streambuddy-companion-firefox.zip';

export const isFirefoxBrowser = () => /Firefox\//.test(navigator.userAgent);
